export enum SettingKeys {
	SBER_MQ_ASSIGNMENT = 'sber_mq_assignment',
	CALL_EASY_CALL_REQUEST = 'call_easy_call_request',
	FRONT = 'front',
	OKKO = 'okko',
	OKKO_UPP = 'products',
	IBRO = 'ibro',
	UNI_CHAT = 'uni_chat',
}
